const {
  z,
  HumanisedBooleanLike,
  ArrayOfURLs,
} = require('@reckon-web/next-config/client');
const {
  StringToArray,
} = require('@reckon-web/next-config/src/schema/ArrayLike');

/**
 * @type {import('./__generated__/config').ConfigEnv}
 */
module.exports = {
  // General Application Meta
  APPLICATION_LOCALSTORAGE_PREFIX: z.string().default('identity_'),
  APPLICATION_DISPLAY_NAME: z.string().default('Reckon Identity'),

  // 3rd Party Services
  APPLICATION_SENTRY_DSN: z
    .string()
    .default(
      'https://293af8d5464e2423b98b2951a08c874e@o378482.ingest.sentry.io/4505949202219008'
    ),
  APPLICATION_GOOGLE_GTM_APIKEY: z.string().default('GTM-TLRWFL5'),
  APPLICATION_GOOGLE_GOOGLE_ANALYTICS_KEY: z.string().default('UA-201178475-1'),
  APPLICATION_GOOGLE_TAGID: z.string().default(''),
  APPLICATION_BRANCHIO_APIKEY: z.string().default(''),
  APPLICATION_APPCUES_APPID: z.string().default(''),

  // Auth Config
  APPLICATION_AUTH_MICROSOFT_CLIENTID: z
    .string()
    .default('6a65c2b2-5607-48d2-92c2-0149930c48db'),
  APPLICATION_AUTH_REGION: z.string().default('ap-southeast-2'),
  APPLICATION_AUTH_BACKEND: z
    .string()
    .default('https://portal-backend.dev.reckoncloud.com.au'),
  APPLICATION_AUTH_OAUTH_SCOPE: z
    .string()
    .default('profile,phone,email,openid'),
  APPLICATION_AUTH_OAUTH_RESPONSE_TYPE: z.string().default('token'),
  APPLICATION_AUTH_OAUTH_DEFAULTCLIENTID: z.string().default('portal'),
  APPLICATION_AUTH_OAUTH_REDIRECT_SIGNIN: z
    .string()
    .default('https://reckon-auth.dev.reckoncloud.com.au'),
  APPLICATION_AUTH_OAUTH_REDIRECT_SIGNOUT: z
    .string()
    .default('https://reckon-auth.dev.reckoncloud.com.au'),
  APPLICATION_AUTH_WEBCLIENTID_PORTAL_DOMAIN: z
    .string()
    .default('https://genesis.dev.reckoncloud.com.au'),
  APPLICATION_AUTH_WEBCLIENTID_PORTAL_REDIRECTURL: z
    .string()
    .default('https://genesis.dev.reckoncloud.com.au/#callback'),
  APPLICATION_AUTH_WEBCLIENTID_WHITELISTDOMAINS: StringToArray(z.string())
    .default(
      'dev.reckoncloud.com.au,reckoncloud.com.au,reckonone.com,stg.deadlydigits.com.au,apps.reckon.com,app.deadlydigits.com.au,reckon.com,localhost'
    )
    .describe(
      'Comma separated list of domains to whitelist for various purposes. This is used to ensure that the application only sends users to domains that are safe.'
    ),
  APPLICATION_AUTH_WEBCLIENTID_DD_DOMAIN: z
    .string()
    .default('https://deadlydigits-genesis.dev.reckoncloud.com.au'),
  APPLICATION_AUTH_WEBCLIENTID_DD_REDIRECTURL: z
    .string()
    .default('https://deadlydigits-genesis.dev.reckoncloud.com.au/#/callback'),

  APPLICATION_AUTH_WEBCLIENTID_PAYROLL_REDIRECTURL: z
    .string()
    .default('https://payroll.dev.reckoncloud.com.au'),

  APPLICATION_AUTH_WEBCLIENTID_PLATFORM_REDIRECTURL: z
    .string()
    .default('https://platform.dev.reckoncloud.com.au'),

  APPLICATION_AUTH_USE_COOKIE_STORAGE: HumanisedBooleanLike.default(true),

  // Content
  APPLICATION_LINK_FORGOTEMAIL: z
    .string()
    .default('https://help.reckon.com/article/k3b3s7d777'),
  APPLICATION_LINK_SERVICETERMS: z
    .string()
    .default('https://www.reckon.com/au/terms'),
  APPLICATION_LINK_POLICY: z
    .string()
    .default('https://www.reckon.com/au/policies/privacy'),
  APPLICATION_LINK_SMSHELP: z
    .string()
    .default('https://help.reckon.com/article/nb9lxbuv0r'),
  APPLICATION_RECKON_LOGO_URL: z
    .string()
    .default(
      'https://images.dev.reckoncloud.com.au/images/ReckonReckonApplicationLogo.svg'
    ),
  APPLICATION_RECKON_APP_LOGO_URL: z
    .string()
    .default(
      'https://images.dev.reckoncloud.com.au/images/ReckonApplicationLogo.svg'
    ),
  APPLICATION_SWITCH_TO_RECKON_URL: z
    .string()
    .default(
      'https://www.reckon.com/au/support/data-migration-switch-to-reckon/'
    ),
  APPLICATION_CAPTCHA_SITE_KEY: z
    .string()
    .default('6LfJWGcUAAAAADm-KTL5jmLD6mE3uCzH4OQGEh_b'),
};
